var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"headPanel_main"},[_c('div',{staticClass:"hm_con"},[_c('div',{staticClass:"icon_back",on:{"click":_vm.goback}},[_c('img',{attrs:{"src":require("@/assets/img/back.png"),"alt":""}})]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.title))])])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@14.2.4@vue-loader/lib/template-compiler?{"id":"data-v-1b20da86","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/_vue-loader@14.2.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/headPanel.vue
// module id = null
// module chunks = 